import { render } from "./dealerGroupsList.vue?vue&type=template&id=40416ad8&scoped=true"
import script from "./dealerGroupsList.vue?vue&type=script&lang=js"
export * from "./dealerGroupsList.vue?vue&type=script&lang=js"

import "./dealerGroupsList.vue?vue&type=style&index=0&id=40416ad8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40416ad8"]])

export default __exports__